const parseDateValueToTwoDigits = number => (number.length === 1 ? `0${number}` : number);

export const formatDOBWithHypens = (year, month, day) => {
  const parsedDay = parseDateValueToTwoDigits(day.trim());
  const parsedMonth = parseDateValueToTwoDigits(month.trim());

  return `${year.trim()}-${parsedMonth}-${parsedDay}`;
};
